export default __webpack_public_path__ + "static/Flint-2272905fc9387fb47f94c642ac8b2b3b.png";